import { globalTypes } from '../types';
import { reduceAction } from '../helpers';

import types from './types';

export const initialState = () => ({
    orders: [],
    offlineOrders: [],
    loading: false,
    isEmpty: true,
    isEmptyOffline: true,
    anyLoyalty: false,
    showOrdersEmptyMessage: false,
    showOrdersEmptyMessageOffline: false,
    ordersForExtService: {},
    orderDetailForExtService: {},
    additionalPagination: {},
    offlineOrdersApiError: false,
});

const reducers = (state = initialState(), action) => {
    switch (action.type) {
        case globalTypes.INITIALIZE:
            return initialState();

        case types.SET_LOADING:
            return reduceAction(state, 'loading', !!action.payload);

        case types.SET_ORDERS_DATA: {
            const data = action.payload;
            return {
                ...state,
                ...data,
                isEmpty: !(data.orders && data.orders.length),
                anyLoyalty: data.orders.some(order => order.redeemLoyaltyPoints > 0),
                showOrdersEmptyMessage: !(data.orders && data.orders.length),
            };
        }
        case types.SET_OFFLINE_ORDERS_DATA: {
            const data = action.payload;
            return {
                ...state,
                offlineOrders: data.orders,
                isEmptyOffline: !(data.orders && data.orders.length),
                anyLoyalty: data.orders.some(order => order.redeemLoyaltyPoints > 0),
                showOrdersEmptyMessageOffline: !(data.orders && data.orders.length),
            };
        }
        case types.SET_OFFLINE_API_ERROR: {
            return {
                ...state,
                offlineOrdersApiError: !!action.payload,
            };
        }
        case types.ADD_ORDERS_DATA: {
            const data = action.payload;
            return {
                ...state,
                ...data,
                orders: [...state.orders, ...data.orders],
            };
        }
        case types.SET_CURRENT_PAGE: {
            return {
                ...state,
                additionalPagination: action.payload,
            };
        }
        case types.SET_ORDERS_FOR_EXT_SERVICE: {
            const data = action.payload;
            const key = Object.keys(data)[0];
            const removeProp = key;
            const { [removeProp]: remove, ..._ordersForExtService } = state.ordersForExtService;
            const _ordersForExtService_ = {
                ..._ordersForExtService,
                [key]: data[key],
            };
            return { ...state, ordersForExtService: _ordersForExtService_ };
        }

        case types.SET_ORDER_DETAIL_FOR_EXT_SERVICE: {
            const data = action.payload;
            const key = Object.keys(data)[0];
            const removeProp = key;
            const {
                [removeProp]: remove,
                ..._orderDetailForExtService
            } = state.orderDetailForExtService;
            const _orderDetailForExtService_ = {
                ..._orderDetailForExtService,
                [key]: data[key],
            };
            return { ...state, orderDetailForExtService: _orderDetailForExtService_ };
        }

        default:
            return state;
    }
};

export default reducers;
